import React, {Component} from 'react';
import {Container, Row, Col, Button} from 'reactstrap';

class Page500 extends Component {
    render() {
        return (
            <Container className="page-500">
                <Row className="justify-content-center">
                    <Col md="6">
                        <span className="clearfix">
                            <h1 className="float-left display-3 mr-4 white-text-color">500</h1>
                            <h4 className="pt-2 magenta-text-color">Houston, we have a problem!</h4>
                            <p className="text-muted float-left">The page you are looking for is temporarily unavailable.</p>
                        </span>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default Page500;



// WEBPACK FOOTER //
// ./src/containers/Page500.js